module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Volume"
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_108532-00001"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#/9781847675705_tableofcontents"
    }
  }, [_c('i', [_vm._v("The Story of My Boyhood and Youth")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f188e71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675705_volume_01.vue
// module id = 69
// module chunks = 0